;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      business_name: null,
      business_reg_no: null,
      business_pin: null,
      availableServices: [],
      selectedServices: [],
      user_params: null,
      user_details: [],
      services: null,
      missing_business_name: false,
      missing_business_reg_no: false,
      missing_business_pin: false,
      consumer_secret: null,
      consumer_key: null,
      api_token: null
    };
  },
  mounted: function mounted() {
    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
  },
  created: function created() {
    this.user_params = this.$attrs["user_details"];
    this.services = this.$attrs["services"];
    this.set_services();
    this.set_user_details();
  },

  methods: {
    set_services: function set_services() {
      this.availableServices = this.services;
    },
    set_user_details: function set_user_details() {},
    validate: function validate() {
      if (this.business_reg_no == null) {
        this.missing_business_reg_no = true;
        return;
      } else {
        this.missing_business_reg_no = !true;
      }
      if (this.business_name == null) {
        this.missing_business_name = true;
        return;
      } else {
        this.missing_business_name = !true;
      }
      if (this.business_pin == null) {
        this.missing_business_pin = true;
        return;
      } else {
        this.missing_business_pin = !true;
      }
      this.complete_signup();
    },
    authorize_and_execute: function authorize_and_execute(api_url, callback_url, fpayload) {
      var _this = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this.api_token = response.data.token;
        _this.do_post(_this.api_token, api_url, callback_url, fpayload);
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong. Contact Pesaflow Support"
        });
      }).then(function () {});
    },
    generate_full_payload: function generate_full_payload() {
      var business_data = {
        business_name: this.business_name,
        business_reg_no: this.business_reg_no,
        business_ra_pin: this.business_pin,
        services: this.selectedServices
      };
      var new_user_params = (0, _assign2.default)(this.user_params, business_data);
      return new_user_params;
    },
    complete_signup: function complete_signup() {
      var api_url = "/api/self/signup";
      var callback_url = "/signin";
      var payload = this.generate_full_payload();
      this.authorize_and_execute(api_url, callback_url, payload);
    },
    do_post: function do_post(api_token, api_url, callback_url, payload) {
      var api_headers = { Authorization: "Bearer " + api_token };
      _sweetalert2.default.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, proceed",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(setup) {
          return Vue.axios.post(api_url, payload, { headers: api_headers }).then(function (response) {
            window.location.href = callback_url;
          }).catch(function (error) {
            _sweetalert2.default.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong. Contact Support for further assistance"
            });
          }).then(function () {});
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_sweetalert2.default.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _sweetalert2.default.fire("Success", "Thank you for registering. You will receive an email confiration and with instructions shortly", "success");
        }
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group citizens residents account-marker"},[_c('label',[_vm._v("Business Name")]),_vm._v(" "),(_vm.missing_business_name)?_c('span',{staticClass:"error"},[_vm._v("*")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_name),expression:"business_name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Business Name","maxlength":"20"},domProps:{"value":(_vm.business_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.business_name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group citizens residents account-marker"},[_c('label',[_vm._v("Business Registration Number")]),_vm._v(" "),(_vm.missing_business_reg_no)?_c('span',{staticClass:"error"},[_vm._v("*")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_reg_no),expression:"business_reg_no"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Business Registration Number","maxlength":"20"},domProps:{"value":(_vm.business_reg_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.business_reg_no=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group citizens residents account-marker"},[_c('label',[_vm._v("Revenue Authority Pin Number")]),_vm._v(" "),(_vm.missing_business_pin)?_c('span',{staticClass:"error"},[_vm._v("*")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_pin),expression:"business_pin"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Revenue Authority Pin Number","maxlength":"20"},domProps:{"value":(_vm.business_pin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.business_pin=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group citizens residents account-marker"},[_c('label',[_vm._v("Select Agency services that you would like to offer")]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","label":"name","options":_vm.availableServices},model:{value:(_vm.selectedServices),callback:function ($$v) {_vm.selectedServices=$$v},expression:"selectedServices"}})],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-lg btn-block btn-primary lift mb-3",on:{"click":_vm.validate}},[_vm._v("\n      Complete Setup\n    ")])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25298486", __vue__options__)
  } else {
    hotAPI.reload("data-v-25298486", __vue__options__)
  }
})()}